/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FullenrichCreditsUsage } from './FullenrichCreditsUsage';
import {
    FullenrichCreditsUsageFromJSON,
    FullenrichCreditsUsageFromJSONTyped,
    FullenrichCreditsUsageToJSON,
    FullenrichCreditsUsageToJSONTyped,
} from './FullenrichCreditsUsage';

/**
 * 
 * @export
 * @interface OrgUsageResponse
 */
export interface OrgUsageResponse {
    /**
     * 
     * @type {FullenrichCreditsUsage}
     * @memberof OrgUsageResponse
     */
    fullenrichCredits: FullenrichCreditsUsage;
}

/**
 * Check if a given object implements the OrgUsageResponse interface.
 */
export function instanceOfOrgUsageResponse(value: object): value is OrgUsageResponse {
    if (!('fullenrichCredits' in value) || value['fullenrichCredits'] === undefined) return false;
    return true;
}

export function OrgUsageResponseFromJSON(json: any): OrgUsageResponse {
    return OrgUsageResponseFromJSONTyped(json, false);
}

export function OrgUsageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUsageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fullenrichCredits': FullenrichCreditsUsageFromJSON(json['fullenrich_credits']),
    };
}

  export function OrgUsageResponseToJSON(json: any): OrgUsageResponse {
      return OrgUsageResponseToJSONTyped(json, false);
  }

  export function OrgUsageResponseToJSONTyped(value?: OrgUsageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fullenrich_credits': FullenrichCreditsUsageToJSON(value['fullenrichCredits']),
    };
}

